import { container } from "tsyringe";

type Constructor<T> = new (...args: any[]) => T;

class Container {
    get<T>(key: string | Constructor<T>): T {
        if (typeof key === "string") {
            return container.resolve<T>(key);
        }
        return container.resolve<T>(key);
    }

    put<T>(key: string, clazz: Constructor<T>): void {
        container.register(key, {
            useClass: clazz,
        });
    }
}

export const DI = new Container();
